import React, {useState} from 'react'
import { CSSTransition } from 'react-transition-group'
import './header.css'
import logo from '../images/logo.png'
import { FaSearch, FaInfo } from 'react-icons/fa'
import { FormattedMessage} from 'react-intl'

function Header(props) {
  const [localeBtn, setLocaleBtn] = useState(false)
 
  const temp = props.locale.substr(0, 2)
  let localeText
  if (temp === 'zh')
    localeText = '中'
  else if (temp === 'ja')
    localeText = '日'
  else
    localeText = 'EN'

  const handleClick = locale => {
    props.handleLangClick(locale)
    setLocaleBtn(false)
  }

  return (
    <div className='header'>
      <img className='header-logo' src={logo} alt="logo"></img>
      <div className='header-title'><FormattedMessage id="title"/></div>
      <div className='header-btn header-lang-btn'
           onClick={()=>{setLocaleBtn(!localeBtn)}}
      >
        { localeText }
        <CSSTransition classNames='header-lang-content' in={localeBtn} timeout={300}>
        <div className='header-lang-content'>
          <div className='header-lang-triangle'></div>
          <div className='header-lang-option-div'>
            <div className='header-lang-option' onClick={()=>handleClick('zh-TW')}>繁體中文</div>
            <div className='header-lang-option' onClick={()=>handleClick('ja-JP')}>日本語</div>
            <div className='header-lang-option' onClick={()=>handleClick('en-US')}>English</div>
          </div>
        </div>
        </CSSTransition>
      </div>
      {/* <div className='header-btn' onClick={()=>props.handleInfoClick(true)}><FaInfo/></div> */}
      <div className='header-btn header-aside-btn' onClick={()=>props.handleAsideClick('reverse')}><FaSearch/></div>
    </div>
  )
}

export default Header